module.exports = __webpack_public_path__ + "img/Superrent_App_Mockup_02.0323ffbb.png";